import React from 'react'; 
import i18n from "i18next";
import { Button, Tooltip, Row, Col, Modal, Tabs, message, Collapse } from 'antd';
import { CloseOutlined, CreditCardOutlined, EditOutlined, FileAddOutlined, 
  FileZipOutlined, DisconnectOutlined, SnippetsOutlined, RollbackOutlined } from '@ant-design/icons'
import { LoadingComponent } from '../../utils/ui'
import { getNameAsset } from '../../components/adms/helper';
import AssetData from '../../components/adms/AssetData'
import TaxonomyCard from '../../components/skos/TaxonomyValues'
import { AdmsRepository, AdmsAsset, ModelViews} from '../../redux';
import WikiValues from '../../components/wiki/WikiValues';
import AssetDistributions from '../../components/adms/AssetDistributions';
import { DetailLinkCard } from '../../components/adms/DetailLinkCard';
import ViewsProxy from '../models/ViewsProxy';
import SelectProperty from '../../components/widgets/SelectProperty';
import ProcessInstaceLink from '../../components/lifecycle/ProcessInstaceLink';
import ExportToDocument from '../../components/export/ExportToDocument';
import {JSONLDScript} from '../../components/adms/JSONLDScript';
import JSONLDScriptDialog from '../../components/adms/JSONLDScriptDialog';
import ExportCard from '../../components/export/ExportCard';
import AssetDelete from '../../components/adms/AssetDelete';
import { filterAddedPredicates } from '../helper';

const ButtonGroup = Button.Group;
const { confirm } = Modal;
const { TabPane } = Tabs;
const { Panel } = Collapse;

const AssetTitle = names => {
    const single = names.length = 1;
    return (single)? names[0]: <span>names.map(name => <p>{name}</p>)</span>;
}

/**
 * 
 * @param {*} formRef 
 * @param {*} IRI - текущий выбранный элемент (IRI)
 * @param {*} factory - фабрика получения информкции о списка доступных свойств и их аннотации
 * @param {*} existing - массив существующих у объекта свойств (предикат + объекта)
 * @param {*} lang  - текущий язык
 * @param {*} onFinishOperation - callback для добавления
 * @param {*} onCancelOperation - callback для отмены
 * @returns 
 */
const showAddProperty = (formRef=f=>f, IRI, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} open={true} title="Добавление свойства" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}>
        <SelectProperty formRef={formRef} subjectIri={IRI} existing={existing} 
          factory={factory} lang={lang}/>
	  </Modal>
}

const showViewDetail = (formRef=f=>f, selected, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} open={true} title="Детальная информация" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}	cancelButtonProps={{ disabled: true, dispaly: "none" }}>
        <DetailLinkCard triplet={selected} factory={factory}/>
	  </Modal>
}

const showJSONLDScript = (onCloseOperation=f=>f) => {
	return <Modal style={{minWidth: "80%"}} open={true} title="Микроразметка" okText="Закрыть" 
		onOk={onCloseOperation}	cancelButtonProps={{ style: { display: 'none' } }}>
        <JSONLDScriptDialog/>
	  </Modal>
}

const decodeIRIParams = (router) =>{
  // В v6 * уже содержит “остаток пути”, поэтому не нужно вручную делать substring(match.url.length) и зависеть от match.url.
  // if (router && match.url == "/adms/http:" && router.params.id && router.location && router.location.pathname){
  //   return decodeURIComponent(router.params.id+router.location.pathname.substring(match.url.length))
  // };
  return (router && router.params && router.params.id)?decodeURIComponent(router.params.id):null;
}

const isDataset = (values) => {
  if (Array.isArray(values) && values.length>0){
    return values.filter(element => element.predicat && element.predicat.value === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" && 
        element.object && element.object.value === "http://www.w3.org/ns/dcat#Dataset").length>0;
  }
  return false;
}

/** Карточка актива. Отображаются данные из vasset.
 * обеспечивает загрузку данных по ассету, так как дочерние компоненты должны используать уже загруженные данные.
 * Так же контролирует отображение в режимах редактирования и перевода.
 * 
 * 20200530 см. https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html
 * перевод для асинхронного вызова загрузки карточки 
 */
class AssetCard extends React.Component {
  
  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false, 			  //Флаг загрузки, карточки ADMS
      operation: "view",    //Текущая операция над карточкой
      detail: undefined,    //Элемент, для которого требуется получение дополнительной информацией
      adding: false,        //Флаг, для отображения далога добавления нового свойства
      views: false,         //Загружены представления содержимого актива
      jsonld: false,        //Флаг, для отображения далога c микроразметкой
      exportCard: false,    //Флаг, для отображения далога c экспортом карточки
      deleteCard: false,    //Флаг, для отображения далога c удалением карточки
      activeKey: undefined, //Номер активной вкладки,
      addedPredicates: [],  //Добавленные предикаты
    }
  }
  
  formRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    //console.log("AssetCard.js static getDerivedStateFromProps(props, state)", props, state);//, decodeIRIParams(props.match, props.location), props.IRI, props.state, props, state);
    if ((decodeIRIParams(props.router)!=props.IRI)||(props.state=="empty") || !props.IRI){
    //||(props.vviews && (props.vviews.iri != props.IRI))) {
      return {loaded: false, operation: "view", detail: undefined, adding: false};
    }
    if ((decodeIRIParams(props.router)==props.IRI)||(props.state=="loaded")){
        return { ...state, loaded: true}
    }
    return null; // Return null to indicate no change to state.
  }

  componentDidMount() {
    const IRI = decodeIRIParams(this.props.router);
    if (!this.state.loaded && (IRI!=this.props.IRI) || (this.props.state=="empty")){
      Promise.all([
        this.props.onReload(AdmsAsset, this.props.catalog, IRI),
        this.props.onReloadViews(ModelViews, IRI)
      ]);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const IRI = decodeIRIParams(this.props.router);
    //Проверка после сохранения добавленного свойства
    if (prevProps.values !== this.props.values && this.state.addedPredicates.length > 0) {
      const addedPredicates = filterAddedPredicates(
        this.state.addedPredicates,
        this.props.values
      );

      if (addedPredicates.length !== this.state.addedPredicates.length) {
        this.setState({ addedPredicates });
        return;
      }
    };
    if (!this.state.loaded && ((IRI!=this.props.IRI)||(this.props.state=="empty") || !this.props.IRI))
      this.props.onReload(AdmsAsset, this.props.catalog, IRI).then( response => {
        this.props.onReloadViews(ModelViews, IRI).then(views => {
          //После считывания информации о доступных представлениях проверить необходимость открыть вкладку со списокм представлений
          const activeKey = (this.props.router.location.search && this.props.router.location.search.indexOf('view=')>0)? "3" : undefined;
          this.setState({views: true, activeKey});
        });
      });
  }

  callbackSelectTab(key) {
    console.log(key);
    this.setState({activeKey: undefined});
  }
      
  onSelectOperation(e, operation) { 
    e.preventDefault();
    const { catalog, IRI, values, lang, factory, onDeleteElement, onUnlinkElement, history, router} = this.props;
    if (operation=="delete"){
      this.setState({operation, deleteCard: true});      
            // confirm({ title: 'Удалить выбранный элемент? Данные карточки будут удалены безвозвратно!.', content: getNameAsset(values, lang), 
            //     okText: 'Да', okType: 'danger', cancelText: 'Нет',
            //     onOk() { 
            //         onDeleteElement(AdmsRepository, catalog, IRI)
            //         .then (result =>{
            //             console.log("onDeleteElement", result);
            //             message.success("Запись удалена.");
            //             if (history) history.push("/adms");
            //         })
            //     },
            //     onCancel() {},
            //   });
      return;
    };
    if (operation=="unlink"){
      confirm(
        { title: 'Исключить элемент из каталога (разорвать связь с каталогом)',
          content: `Данные карточки  "${getNameAsset(values, lang)}" не будут удалены.`, 
          okText: 'Да', okType: 'danger', cancelText: 'Нет',
          onOk() {
              onUnlinkElement(AdmsRepository, catalog, IRI)
              .then (result =>{
                  console.log("onUnlinkElement", result);
                  message.success("Связь удалена.");
                  if (history) 
                    history.push("/");
              })
          },
          onCancel() {},
        });
      return;
    };
    //Добавление нового свойства
    if (operation=="add"){
      this.setState({operation, adding: true});
      return;
    };
    if (operation=="jsonld"){
      this.setState({operation, jsonld: true, addedPredicates:[]});
      return;
    };
    if (operation == "export"){
      this.setState({operation, exportCard: true});
      return;      
    }
    if (operation == "view"){
      this.setState({operation, addedPredicates:[]});
      return;
    }
    if (operation == "back"){
      if (router) 
        router.navigate(
          this.props.getBaseRoutePath
          ? this.props.getBaseRoutePath("adms") 
          : "/adms"
        );
      return;
    };
    this.setState({operation});
  }

  /** Слушатели различных действий */
  handlers(e, triplet, operation) {
    e.preventDefault();
    if (operation== "detail" && this.props.onDetailElement) 
      this.props.onDetailElement(AdmsAsset, this.props.catalog, triplet)
      .then (result =>{
        //console.log("handlers(e, triplet, operation)", result);
        this.setState({detail: triplet});
    });
  }

  /** Отмена всех действий */
  cancelOperation(){
    this.setState({detail: undefined, adding: false, operation: "view", 
      jsonld: false, exportCard: false, deleteCard: false});
  }

  /** Вызывается при добавлении нового свойства. Данные см. SelectProperty.js
   * После добавление в state сохраняется IRI добавленного совойства. 
   * Это IRI добавляется в карточку. Редактирование object происходит 
   * как при редактировании формы. После сохранения предикат и object фиксируется 
   * в графе (subject - IRI карточки)
   */
  submitAddProperty() {
    this.setState({detail: undefined, adding: false, operation: "edit"});
    const form  = this.formRef.current;
    form.validateFields()
     .then((values) => {
        const addedPredicates = [ ... this.state.addedPredicates, {object:{state: 'new'}, predicat : {type: 'uri', value: values.predicateIri}}];
        this.setState({detail: undefined, adding: false, operation: "edit", addedPredicates});
    }).catch((errorInfo) => {
      console.log(errorInfo);
    });
  };

  render() {
    //console.log(this);
    let { loaded, operation, detail, adding, activeKey, jsonld, exportCard, deleteCard, addedPredicates} = this.state;
    const { values, lang, factory, history, IRI, vviews, isSignedIn, inGroup} = this.props;
    const asset_json = {id: IRI};
    //Флаг, что есть представление для отображение содержимого 
    const views = vviews && Array.isArray(vviews.views) && vviews.views.length>0;
    //Представления, которые могут быть отображены
    const showViews = (views)? vviews.views.filter(view => !view.hide_in_list): vviews.views;
    //Описание view, если оно одно в списке
    const view = (views && showViews.length==1)? showViews[0]: undefined;
    const hasJsonld = isDataset(values);
    const assetTitle = AssetTitle(getNameAsset(values, lang));
    return (
      (!loaded? <LoadingComponent />:
        <span>
          <JSONLDScript />
          <Row>
            <Col className="asset_title" span={24}>{assetTitle}</Col>
          </Row>
          <Row>
            <Tabs defaultActiveKey="1" activeKey={activeKey} onChange={(key)=>this.callbackSelectTab(key)} type="card">
              <TabPane tab={i18n.t('views.adms.card_tab_card')} key="1">
                <div className="csi_wrapper_content csi_inner_asset" resource={IRI}>
                    <Row>
                        <Col className="asset_title" span={16} style={{"display": "flex"}}>
                          <Tooltip placement="top" title={"Вернуться в список"}>
                            <Button type="dashed" icon={<RollbackOutlined />} onClick={(e)=> this.onSelectOperation(e, "back")}/>
                          </Tooltip>                    
                        </Col>
                        <Col className="asset_title_buttons" span={8} style={{"display": "flex", "flexDirection": "row-reverse"}}>
                          {isSignedIn && inGroup.Operator && (
                            <ButtonGroup>
                              {operation!="view" && (
                                <>
                                  <Tooltip placement="top" title={"Разорвать связь с каталогом."}>
                                    <Button icon={<DisconnectOutlined />} onClick={(e)=> this.onSelectOperation(e, "unlink")}/>
                                  </Tooltip>
                                    &nbsp;&nbsp;
                                  <Tooltip placement="top" title={"Добавление свойства"} >
                                      <Button icon={<FileAddOutlined />} onClick={(e)=> this.onSelectOperation(e, "add")}/>
                                  </Tooltip>
                                    &nbsp;&nbsp;
                                  <Tooltip placement="top" title={"Режим просмотра данных"}>
                                    <Button type="primary" icon={<CreditCardOutlined />} onClick={(e)=> this.onSelectOperation(e, "view")} />
                                  </Tooltip>
                                </>
                              )}
                              {operation != "edit" && (
                                <Tooltip placement="top" title={"Режим редактирования"}>
                                    <Button icon={<EditOutlined />} onClick={(e)=> this.onSelectOperation(e, "edit")}/>
                                </Tooltip>
                              )}
                              &nbsp;&nbsp;
                              {operation != "delete"  && (
                                <Tooltip placement="top" title={"Удалить карточку"}>
                                  <Button icon={<CloseOutlined />} onClick={(e)=> this.onSelectOperation(e, "delete")}/>
                                </Tooltip>
                              )}
                            </ButtonGroup>
                          )}
                          {!inGroup.Demo && (
                            <>
                              {hasJsonld && (
                                <>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.adms.jsonld_title')}>
                                    <Button icon={<SnippetsOutlined />} onClick={(e)=> this.onSelectOperation(e, "jsonld")}  disabled={operation=="unlink"}/>
                                  </Tooltip>
                                  &nbsp;&nbsp;
                                  <Tooltip placement="top" title={i18n.t('views.adms.export_title')}>
                                    <ExportToDocument element="AssetData" title={assetTitle}/>
                                  </Tooltip>
                                </>
                              )}
                              &nbsp;&nbsp;
                              <Tooltip placement="top" title={i18n.t('views.adms.export_card')}>
                                <Button icon={<FileZipOutlined />} onClick={(e)=> this.onSelectOperation(e, "export")}  disabled={operation=="unlink"}/>
                              </Tooltip>
                            </>
                          )}
                          {adding && showAddProperty(this.formRef, IRI, values, factory, lang, ()=>this.submitAddProperty(), ()=>this.cancelOperation())}
                          {jsonld && showJSONLDScript(()=>this.cancelOperation())}
                          { exportCard && <ExportCard open={true} onClose={()=> this.cancelOperation()} assetId={IRI} values={values} vviews={vviews}/>}
                          { deleteCard && <AssetDelete open={true} onClose={()=> this.cancelOperation()} />}
                        </Col>
                    </Row>
                    <Row id="AssetData">
                        <Col className="assetCardTable" span={16}>
                          <AssetData operation={operation} factory={factory} handlers={(e,t,o)=> this.handlers(e,t,o)} addedPredicates={addedPredicates} 
                            getBaseRoutePath={this.props.getBaseRoutePath} /> 
                          {detail && showViewDetail(this.formRef, detail, factory, ()=>this.cancelOperation(), ()=>this.cancelOperation())}
                        </Col>
                        <Col className="properties_panel_wrapper" span={8}>
                        <Row>
                          <Col span={24}>
                            <TaxonomyCard operation={operation} subject={IRI} predicat="http://www.w3.org/ns/dcat#theme" factory={factory} />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <WikiValues operation={operation} predicat="http://purl.semanticpro.org/ontologies/sksa/wiki" factory={factory} 
                              getBaseRoutePath={this.props.getBaseRoutePath} />
                          </Col>
                        </Row>
                        <Row>
                          <Col span={24}>
                            <AssetDistributions operation={operation} factory={factory} history={history} getBaseRoutePath={this.props.getBaseRoutePath}/>
                          </Col>
                        </Row>
                        </Col>
                    </Row>
                </div>            
        </TabPane>
        { false && (<TabPane tab={i18n.t('views.adms.card_tab_collaboration')} key="2">
          <div className="csi_wrapper_content csi_inner_asset">
            <Row>
              <Collapse accordion>
                <Panel header={i18n.t('views.adms.collaboration.lifecycle_header')} key="1">
                  <ProcessInstaceLink IRI={IRI} />            
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.event_header')} key="2">
                  <p><b>{i18n.t('views.adms.collaboration.event_none')}</b></p>
                </Panel>
                <Panel header={i18n.t('views.adms.collaboration.wiki_header')} key="3">
                  <WikiValues operation={operation} predicat="http://purl.semanticpro.org/ontologies/sksa/wiki" factory={factory} />
                </Panel>
              </Collapse>
            </Row>
          </div>            
        </TabPane>
        )}
        {views && (<TabPane tab={i18n.t('views.adms.card_tab_content')} key="3">
            <ViewsProxy rpc_url={ModelViews.getRpc_url()} asset={asset_json} view={view} location={this.props.router.location} getBaseRoutePath={this.props.getBaseRoutePath}/>
          </TabPane>)
        }
      </Tabs>
      </Row>
      </span>
      )
    )
  }
}

export default AssetCard;